import { createAsyncActionTypes } from '@mews/framework';
import prefix from '../app/prefix';

export const INITIALIZE_BILLING = prefix('INITIALIZE_BILLING');
export const [INITIALIZE_BILLING_STARTED, INITIALIZE_BILLING_SUCCEEDED, INITIALIZE_BILLING_FAILED] =
    createAsyncActionTypes(INITIALIZE_BILLING);
export const SET_ACCOUNT_IDS = prefix('SET_ACCOUNT_IDS');
export const EXPAND_ALL = prefix('EXPAND_ALL');
export const COLLAPSE_ALL = prefix('COLLAPSE_ALL');
export const TOGGLE_EXPAND_BILL = prefix('TOGGLE_EXPAND_BILL');
export const REPLACE_EXPANDED_BILL = prefix('REPLACE_EXPANDED_BILL');
export const CHANGE_BILLING_GROUPING = prefix('CHANGE_BILLING_GROUPING ');
export const TOGGLE_HIGHLIGHT_ORDER_ITEM = prefix('TOGGLE_HIGHLIGHT_ORDER_ITEM');
